/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonbtncancel2Inputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Commonbtncancel2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonbtncancel2 = /** @type {((inputs?: Commonbtncancel2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonbtncancel2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cancel")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar")
	return /** @type {LocalizedString} */ ("Отмена")
});
export { commonbtncancel2 as "commonBtnCancel" }